/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CosmosComponentContextProps } from "@cosmos/components";
import { PageSlugProps } from "@cosmos/next-common";
import { notFound } from "next/navigation";

import { CosmosBlogDetailPage } from "../cosmos-blog-detail";
import { CosmosEulaKeyPage } from "../cosmos-eula-key";
import { CosmosHeroAndSectionsPage } from "../cosmos-hero-and-sections";
import { CosmosLegalContentPage } from "../cosmos-legal-content";
import { cosmosRedirectPage } from "../cosmos-redirect/CosmosRedirectPage.page";
import { CosmosResearchPage } from "../cosmos-research";
import { CosmosSearchPage } from "../cosmos-search";

import { getKey, checkValidParams } from "./selector";

export const templateSelector = async (
	props: PageSlugProps,
	hygraphLocales: string[],
	componentContext?: CosmosComponentContextProps,
): Promise<React.JSX.Element> => {
	const valid = checkValidParams(props);
	if (!valid) {
		return notFound();
	}

	const key = await getKey(props, hygraphLocales);

	if (!key) {
		return notFound();
	}

	const restProps = {
		slug: "",
		hygraphLocales,
		componentContext,
	} as const;

	switch (key) {
		case "cosmosPageBlogDetail": {
			return <CosmosBlogDetailPage {...props} {...restProps} />;
		}
		case "cosmosPageEulaKey": {
			return <CosmosEulaKeyPage {...props} {...restProps} />;
		}
		case "cosmosPageLegalContent": {
			return <CosmosLegalContentPage {...props} {...restProps} />;
		}
		case "cosmosPageRedirect": {
			return cosmosRedirectPage(props);
		}
		case "cosmosPageSearch": {
			return <CosmosSearchPage {...props} {...restProps} />;
		}
		case "cosmosPageResearch": {
			return <CosmosResearchPage {...props} {...restProps} />;
		}
		default:
			return <CosmosHeroAndSectionsPage {...props} {...restProps} />;
	}
};
